export const TEXT_CHANGE_EVENT = 'text_change_event';
